<template>
  <div
    @click="selectBranch(branch)"
    :id="`element${branch.IdSucursal}`"
    :ref="`element${branch.IdSucursal}`"
    class="branches-verification__item"
  >
    <div class="branches-verification__item-title">
      Sucursal {{ branch.Nombre }}
    </div>
    <div class="branches-verification__subtitle-wrapper">
      <p class="branches-verification__subtitles-item">
        {{ branch.Domicilio | textOverflow }}.
      </p>
      <p class="branches-verification__subtitles-item">
        {{ branch.Provincia }}
      </p>
      <p class="branches-verification__subtitles-item">{{ branch.Ciudad }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BranchVerification",
  props: {
    branch: Object,
  },
  filters: {
    textOverflow(value) {
      if (value.length >= 40) return value.substring(0, 40) + "...";
      else return value;
    },
  },
  methods: {
    selectBranch(branch) {
      this.$emit("addClass", branch);
    },
  },
};
</script>
